// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ����������� ���� ����� � ����������
import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

// ���������� ���� ������������ �� Telegram ��� ������ 'en' �� ���������
const userLanguage = window.Telegram?.WebApp?.initDataUnsafe?.user?.language_code || 'en';

i18n
  .use(initReactI18next) // ���������� react-i18next
  .init({
    resources: {
      en: {
        translation: translationEN
      },
      ru: {
        translation: translationRU
      }
    },
    lng: userLanguage, // ������������� ����, ���������� �� Telegram
    fallbackLng: 'en', // ���� �� ���������, ���� ���� ������������ �� ��������������

    interpolation: {
      escapeValue: false // React ��� �������� �� XSS
    }
  });

export default i18n;